import {
  ReportAggregationType,
  ReportDateHistogramType,
} from '@driftt/api-types'

import AggregationBuilder from '../query/AggregationBuilder'

import QueryBuilder from './CallSummaryQueryBuilder'
import * as Parsers from './parsers'

const QueryParsersByMetric = {
  callsMade: (query) => ({
    query,
    parseFunction: Parsers.parseCallsMade,
  }),
  totalCallsMade: (query) => ({
    query,
    parseFunction: Parsers.parseTotalCallsMade,
  }),
  callsMadeByDate: (query) => ({
    query,
    parseFunction: Parsers.parseCumulativeLine,
  }),
  callsByRep: (query) => ({
    query,
    parseFunction: Parsers.parseCallsMadeByRep,
  }),
}

const makeQueries = ({ startDate, endDate, sortConfig, ...queryConfig }) => ({
  callsMade: () =>
    new QueryBuilder(startDate, endDate)
      .withFilters(queryConfig)
      .withFilterGroups(queryConfig)
      .withSort(sortConfig)
      .withPageSize(10)
      .onPage(1)
      .build(),
  callsMadeByDate: () =>
    new QueryBuilder(startDate, endDate)
      .withAggregation(
        new AggregationBuilder(
          'createdAtDate',
          ReportAggregationType.DATE_HISTOGRAM
        )
          .withDocCount()
          .withMinMax(startDate, endDate)
          .withInterval(ReportDateHistogramType.DAY)
          .build()
      )
      .withFilters(queryConfig)
      .withFilterGroups(queryConfig)
      .build(),
  totalCallsMade: () =>
    new QueryBuilder(startDate, endDate)
      .withDocCount()
      .withFilters(queryConfig)
      .withFilterGroups(queryConfig)
      .build(),
  callsByRep: () =>
    new QueryBuilder(startDate, endDate)
      .withAggregation(
        new AggregationBuilder('agentId', ReportAggregationType.TERMS)
          .withSize(10)
          .withDocCount()
          .build()
      )
      .withFilters(queryConfig)
      .withFilterGroups(queryConfig)
      .withSize(0)
      .build(),
})

export const getQuery = (queryConfig, options = {}) => {
  const { metric } = queryConfig
  const queriesByMetric = makeQueries({ ...queryConfig, ...options })
  const query = queriesByMetric[metric]

  if (!query) {
    throw Error(
      `no query found for config: ${metric} - ${JSON.stringify(
        queryConfig
      )} with options: ${JSON.stringify(options)}`
    )
  }

  const queryParser = QueryParsersByMetric[metric]

  return queryParser(query())
}
